import { withErrorBoundary } from 'react-error-boundary';
import styled from 'styled-components';
import type { SelectorButtonProps } from './types';
import dynamic from 'helpers/dynamic';
import useArticleUniverseFilterQuickView from './QuickView/useArticleUniverseFilterQuickView';
import { useContext } from 'react';
import ArticleSearchResponseContext from 'components/pages/ArticleUniverse/components/Filter/context/ArticleSearchResponseContext';
import { getSelectTypeIds } from '../../helpers/isSelected';
import { Button } from 'components/Button';
import { SelectButtonStyling } from 'components/shared/inputs/select/shared/styles';
import { Spacing4 } from 'autogen/design-tokens/tokens';

const StyledSelectButton = styled(Button)`
    min-width: 120px;
    font-weight: normal;
    gap: ${Spacing4};

    ${SelectButtonStyling}
`;

const ArrowDown = styled(dynamic(() => import('icons/ArrowDown.svg?react'), { ssr: false }))`
    width: 16px;
`;

function QuicViewFilter(props: SelectorButtonProps) {
    const { buttonLabel, selectType } = props;
    const [_, toggle] = useArticleUniverseFilterQuickView();
    const articleSearchResponseContext = useContext(ArticleSearchResponseContext);
    const selectedIds = getSelectTypeIds(selectType, articleSearchResponseContext?.data);
    const selectedCount = selectedIds.length;
    const buttonLabelWithCount = selectedCount > 0 ? `${buttonLabel} (${selectedCount})` : buttonLabel;

    return (
        <StyledSelectButton variant={null} onClick={() => toggle({ isOpen: true, props, selectedIds })}>
            {buttonLabelWithCount} <ArrowDown />
        </StyledSelectButton>
    );
}

export default withErrorBoundary(QuicViewFilter, {
    fallback: null,
    onError(error, info) {
        console.error(error, info);
    }
});
